<template>
  <div>
    <el-button v-if="falg" @click="onTop" class="topbtn" icon="el-icon-caret-top" circle></el-button>
  </div>
</template>

<script>
export default {
    data() {
        return {
            falg: false
        }
    },
    mounted() {
        if (!this.isMobile()) {
            window.addEventListener('scroll', this.handleScroll)
        }
    },
    methods: {
        handleScroll(e) {
            // console.log(window.pageYOffset,window.innerHeight, 'jjjjjjjjjjjjjjjjjjjjjjjjjj');
            if (window.pageYOffset > 200) {
                this.falg = true
            } else {
                this.falg = false
            }
        },
        onTop() {
            window.scrollTo(0, 0)
        },
        isMobile(){
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
        }
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
    },
}
</script>

<style scoped>
.topbtn {
  position: fixed;
  right: 100px;
  bottom: 100px;
  z-index: 1000;
  color: #409eff;
  box-shadow: 0 0 6px rgba(0,0,0,.12);
  border: none;
  /* background-color: #fff; */
}
</style>


// WEBPACK FOOTER //
// src/components/newPage/Top.vue